(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};
      this.isCustomer = document.querySelector('.search-item').length > 0;

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
      // Notifications
      if(this.isCustomer) {
        this.fetchUserNotifications();
      }
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
    getAuthToken() {
      return document.cookie
        .split('; ')
        .find(row => row.startsWith('authToken='))
        ?.split('=')[1] || '';
    }
    replaceText(message, notification) {
      return message.replace(/\{\{(.+?)\}\}/g, (_, key) => notification[key.trim()] || '');
    }
    renderNotifications(data) {
      const notifications = data.rows || [];
      let unreadNotificationsCount = data.unreadNotificationsCount || 0;

      const notificationHtml = notifications.map(notification => `
        <div class="notification-item" id="notification-${notification.id}">
          <p class="main ellipsis">${notification?.notification?.title || '--'}</p>
          <p class="notification-msg">${this.replaceText(notification?.notification?.message || '', notification?.notification)}</p>
          <p class="date">${new Date(notification?.createdAt).toLocaleString('en-US', { 
            month: 'long', day: '2-digit', year: 'numeric', hour: '2-digit', minute: '2-digit', hour12: true 
          })}</p>
          <button onclick="document.querySelector('sticky-header').markNotificationAsRead('${notification.id}')">Mark as Read</button>
        </div>
      `).join('');

      document.getElementById('notificationsContainer').innerHTML = notificationHtml;
      document.getElementById('unreadCount').textContent = unreadNotificationsCount;
    }
    async fetchUserNotifications() {
      const authToken = this.getAuthToken();
      if (!authToken) {
        console.error('No auth token found');
        return;
      }

      try {
        const response = await fetch('https://api.xdgesports.com/api/v1/user-notifications?page=1&limit=10', {
          method: 'GET',
          headers: {
            'Authorization': `Bearer ${authToken}`,
            'Content-Type': 'application/json'
          }
        });

        if (!response.ok) {
          throw new Error(`HTTP error! Status: ${response.status}`);
        }

        const data = await response.json();
        this.renderNotifications(data);
      } catch (error) {
        console.error('Error fetching notifications:', error);
      }
    }
    async markNotificationAsRead(notificationId) {
      const authToken = this.getAuthToken();
      if (!authToken) {
        console.error('No auth token found');
        return;
      }

      try {
        const response = await fetch('https://api.xdgesports.com/api/v1/user-notifications/mark-as-read', {
          method: 'PATCH',
          headers: {
            'Authorization': `Bearer ${authToken}`,
            'Content-Type': 'application/json'
          },
          body: JSON.stringify({ notificationId })
        });

        if (!response.ok) {
          throw new Error(`HTTP error! Status: ${response.status}`);
        }

        console.log(`Notification ${notificationId} marked as read.`);
        
        // Update UI
        document.querySelector(`#notification-${notificationId}`)?.classList.add('read');

        // Optionally refresh notifications
        this.fetchUserNotifications();
      } catch (error) {
        console.error('Error marking notification as read:', error);
      }
    }
  }
  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();
})();
